import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import AptosNormal from "../../utils/Customfonts/Aptos.ttf";
import AptosBold from "../../utils/Customfonts/Aptos-Bold.ttf";
import { customFontFamily, loadAndAddFont } from "../srf/SRFPrints/srfsConfig";
import { DateisValid } from "../../utils/components/accuracyandlcandrangesshow";
import UnitechHeaderNew from "../image/certificate_header_nonnabl.png";
import UnitechHeader from "../image/header.png";
import UnitechFooter from "../image/footer.png";

let config = {
  margin: 15,
  borderMagin: 7,
  headerHeight: 70,
  footerHeight: 60,
  footerImgHeight: 45, // New: Height for footer image
  footerTableHeight: 40, // New: Height for footer table with signatures
  fontSize: 9,
  bordergap: 5,
  currentY: 0,
};

// New function to draw the signature footer text
function drawSignatureFooter(doc, totalWidth, totalHeight) {
  const footerStartY = totalHeight - config.footerImgHeight - config.footerTableHeight - config.borderMagin;
  
  doc.setFont("helvetica", "bold"); // Set font to bold
  doc.setFontSize(config.fontSize);
  doc.setTextColor(0);
  
  // Left side text - "Prepared By"
  doc.text( "Prepared By", config.borderMagin + 10, footerStartY + 15, { align: "left" });
  
  // Right side text - "Approved by"
  doc.text( "Approved by", totalWidth - config.borderMagin - 10, footerStartY + 15, { align: "right" });
}

const additionalAccessoriesLabel = (
  doc,
  challanDetails,
  finalY,
  margin,
  totalWidth
) => {
  const accessories = challanDetails?.additionalAccessories;
  // If no accessories, skip rendering and return original finalY
  if (!accessories || accessories.trim() === "") {
    return finalY;
  }
  const tableData = [
    [
      {
        content: "Additional Accessories : ",
        styles: {
          fontStyle: "bold",
          halign: "left",
        },
      },
      {
        content: accessories,
        styles: {
          fontStyle: "normal",
          halign: "left",
        },
      },
    ],
  ];

  doc.autoTable({
    margin: { top: margin, right: margin, bottom: margin, left: margin },
    startY: finalY + 2,
    body: tableData,
    theme: "plain",
    styles: {
      fontSize: config.fontSize,
      cellPadding: { top: 5, left: 1, bottom: 5, right: 1 },
      textColor: 0,
      lineWidth: 0,
      lineColor: [0, 0, 0],
    },
    columnStyles: {
      0: {
        cellWidth: (totalWidth - margin * 2) * 0.2,
        lineColor: [0, 0, 0],
      },
      1: {
        cellWidth: (totalWidth - margin * 2) * 0.8,
        lineColor: [0, 0, 0],
      },
    },
  });

  const newY = doc.lastAutoTable.finalY;
  config.currentY = newY;

  return doc.lastAutoTable.finalY;
};

function generateHeaderSection(doc, companyName, allAddress, challanDetails) {
  const Title = "On Site Calibration Check List";
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 102);
  doc.text(
    Title,
    doc.internal.pageSize.getWidth() / 2,
    config?.headerHeight + config?.margin + 5 + config.bordergap,
    {
      align: "center",
    }
  );

  const startYPos =
    config?.headerHeight + 15 + config.bordergap + config?.margin;
  const row1 = [
    {
      content: "Client",
      styles: { fontStyle: "bold", halign: "left" },
    },
    { content: companyName || "" },
    {
      content: "Address",
      styles: { fontStyle: "bold", halign: "left" },
    },
    { content: allAddress[0]?.address || "" },
  ];
  const row2 = [
    {
      content: "Challan No",
      styles: { fontStyle: "bold", halign: "left" },
    },
    { content: challanDetails?.outChallanNo || "" },
    {
      content: "Dispatch Medium",
      styles: { fontStyle: "bold", halign: "left" },
    },
    { content: challanDetails?.dispatchMedium || "" },
  ];
  const row3 = [
    {
      content: "Outward Date",
      styles: { fontStyle: "bold", halign: "left" },
    },
    { content:  DateisValid(challanDetails?.outwardDate) || "" },
    {
      content: "Expected Return Date",
      styles: { fontStyle: "bold", halign: "left" },
    },
    { content: DateisValid(challanDetails?.expectedReturnDate) || "" },
  ];
  const row4 = [
    {
      content: "Purpose",
      styles: { fontStyle: "bold", halign: "left" },
    },
    { content: challanDetails?.purpose || "", },
     {
      content: "SRF Number",
      styles: { fontStyle: "bold", halign: "left" },
    },
    { content: challanDetails?.srfNo || "", },
  ];
  const tableBody = [row1, row2, row3, row4];
  // Calculate the total available width of the table
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  const columnPercentages = [20, 30, 25, 25];
  const columnWidths = columnPercentages.map((percentage) => {
    return (totalPageWidth * percentage) / 100;
  });
  doc.autoTable({
    startY: startYPos,
    body: tableBody,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      textColor: 0,
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      valign: "middle",
      cellPadding: { top: 5, left: 5, bottom: 5, right: 5 },
    },
    margin: { left: config.margin, right: config.margin },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
    },
  });

  const newY = doc.lastAutoTable.finalY;
  config.currentY = newY;
}

function generateTableWithSummary(
  doc,
  selectedStdIDs,
  margin,
  drawMarginRect,
  letterHead
) {
  const columns = [
    "Sr.No.",
    "Master Equipment Name",
    "Id No",
    "Serial Number",
    "Make",
    "Model",
  ];
  const rows = selectedStdIDs.map((product, i) => [
    i + 1,
    product.standardName || "",
    product.stId || "",
    product.serialNo || "",
    product.make || "",
    product.model || "",
  ]);

  const allRows = [...rows];

  const startY = doc.lastAutoTable.finalY + 15;

  doc.autoTable({
    margin: {
      top: margin + config?.headerHeight + 2,
      right: margin,
      bottom: margin + config?.footerHeight + config?.footerTableHeight + 10, // Updated bottom margin
      left: margin,
    },
    head: [columns],
    body: allRows,
    startY: startY,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: { top: 3, left: 5, bottom: 3, right: 5 },
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: false,
      textColor: 0,
      halign: "center",
      valign: "middle",
    },
    bodyStyles: { halign: "center", valign: "middle" },
    didDrawPage: function () {
      drawMarginRect(doc);
      if (letterHead) {
        addHeaderFooter(doc);
      }
      // Draw signature footer on every page
      // drawSignatureFooter(doc, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
    },
  });

  const newY = doc.lastAutoTable.finalY;
  config.currentY = newY;
}

// Helper function to draw the header and footer images
function addHeaderFooter(doc, letterHeadCompnayType) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let letterHead = letterHeadCompnayType ? UnitechHeader : UnitechHeaderNew;

  // Draw header image at the top (x:0, y:0)
  doc.addImage(letterHead, "PNG", 0, 0, pageWidth, config?.headerHeight);
  doc.addImage(
    UnitechFooter,
    "PNG",
    0,
    pageHeight - config.footerImgHeight,
    pageWidth,
    config?.footerImgHeight
  );
}
function drawMasterReadingTable(
  doc,
  drawMarginRect,
  letterHead,
  totalWidth,
  beforeCalibrationData,
  afterCalibrationData,
  instrumentDataArr 
) {
  const margin = config.margin * 2;
  const columnWidth = (totalWidth - margin) / 4;
  let startY = doc.lastAutoTable.finalY + 15;

  const defaultTableStyles = {
    margin: { 
       top: margin + config?.headerHeight + 2,
      left: config.margin,
      right: config.margin,
      bottom: margin + config?.footerHeight + config?.footerTableHeight + 10 // Updated bottom margin
    },
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 4,
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: false,
      textColor: 0,
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
    },
    bodyStyles: {
      halign: "left",
      valign: "middle",
    },
    didDrawPage: () => {
      drawMarginRect(doc);
      if (letterHead) addHeaderFooter(doc, totalWidth);
      // Draw signature footer on every page
      // drawSignatureFooter(doc, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
    },
  };

  const drawTable = (head, body, columnWidths, additionalHeight = 5) => {
    doc.autoTable({
      ...defaultTableStyles,
      startY,
      head: head ? [head] : undefined,
      body,
      columnStyles: columnWidths.reduce(
        (acc, width, index) => ({ ...acc, [index]: { cellWidth: width } }),
        {}
      ),
    });
    startY = doc.lastAutoTable.finalY + additionalHeight;
  };

  const drawTitle = (title, colSpan = 4) => {
    drawTable(
      null,
      [[{ content: title, colSpan, styles: { halign: "center", fontStyle: "bold" } }]],
      Array(colSpan).fill(columnWidth)
    );
  };

  const drawMasterDetails = (instrument) => {
    const data = [
      ["Instruments Name", `${instrument?.label || ""}`, "Model", `${instrument?.model || ""}`],
      ["Make", `${instrument?.make || ""}`, "Id.No", `${instrument?.stId || ""}`],
      ["Calibration Date", `${DateisValid(instrument?.calDate) || ""}`, "Due Date", `${DateisValid(instrument?.validUpto) || ""}`],
    ];
    drawTable(
      null,
      data.map((row) =>
        row.map((content, idx) => ({
          content,
          styles: idx % 2 === 0 ? { fontStyle: "bold" } : {},
        }))
      ),
      Array(4).fill(columnWidth)
    );
  };

  const drawCalibrationData = (data, h = 5) => {
    if (!data || data.length === 0) return;
    const showParameter = data.some(item => item.parameter);
    const showCmc = data.some(item => item.cmc);
    const visibleCols = 1 + (showParameter ? 1 : 0) + 3 + (showCmc ? 1 : 0) + 1;
    const srNoWidth = 40;
    const remWidth = totalWidth - srNoWidth -1;
    const colWidth = remWidth / (visibleCols - 1);
    const colWidths = [srNoWidth];
    if (showParameter) colWidths.push(colWidth);
    colWidths.push(colWidth - 10, colWidth - 10, colWidth - 10);
    if (showCmc) colWidths.push(colWidth);
    colWidths.push(colWidth);

    const tableHead = [
      "Sr.No",
      ...(showParameter ? ["PARAMETER DESCRIPTION"] : []),
      "STANDARD READINGS",
      "ACTUAL MEASURED READINGS",
      "ERROR",
      ...(showCmc ? ["CMC"] : []),
      "ACCEPTANCE CRITERIA",
    ];

    const tableBody = data.map((item, index) => [
      { content: index + 1, styles: { halign: "center",font: customFontFamily?.normalFont   } },
      ...(showParameter ? [{ content: item.parameter || "", styles: { halign: "center",font: customFontFamily?.normalFont } }] : []),
      { content: item.standardReading || "", styles: { halign: "center",font: customFontFamily?.normalFont   } },
      { content: item.actualMeasuredReading || "", styles: { halign: "center",font: customFontFamily?.normalFont   } },
      { content: item.error || "", styles: { halign: "center",font: customFontFamily?.normalFont   } },
      ...(showCmc ? [{ content: item.cmc || "", styles: { halign: "center",font: customFontFamily?.normalFont   } }] : []),
      {
        content: item.acceptanceCriteria || "",
        styles: { halign: "center",font: customFontFamily?.normalFont   },
        // rowSpan: data.length > 1 ? data.length : 1,
      },
    ]);

    drawTable(
      tableHead,
      tableBody,
      colWidths,
      h
    );

    config.currentY = doc.lastAutoTable.finalY;
  };

  // ✅ Group data by instrumentId (assuming you have that field)
  const grouped = instrumentDataArr.map((instrument) => {
    return {
      instrument,
      before: beforeCalibrationData.filter(
        (d) => d.challanInOutId == instrument.id
      ),
      after: afterCalibrationData.filter(
        (d) => d.challanInOutId == instrument.id
      ),
    };
  });
  // Loop through each instrument
  drawTitle("Master Details");
  grouped.forEach((group, idx) => {
    const hasInstrumentBeforeData = group.before && group.before.length > 0;
    const hasInstrumentAfterData = group.after && group.after.length > 0;
    drawMasterDetails(group.instrument);
    // Only draw "Before Calibration" section if there's data
    if (hasInstrumentBeforeData) {
    drawTitle("Before Calibration - Master Instruments Functional Verification");
    }
    drawCalibrationData(group.before);

    // Only draw "After Calibration" section if there's data
    if (hasInstrumentAfterData) {
    drawTitle(`${group?.instrument?.returnDate ? "                                    " : ""}After Calibration - Master Instruments Functional Verification${group?.instrument?.returnDate ? "                Return Date: " + DateisValid(group.instrument.returnDate) : ""}`);
     }
    drawCalibrationData(group.after, 5);
  });
}

function drawCheckListTable(
  doc,
  drawMarginRect,
  checkPointData,
  letterHead,
  totalWidth
) {
  let startY = config.headerHeight + config.margin + 15;
  const boxWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  startY = doc.lastAutoTable.finalY + 10;

  const tableColumn = ["S.No", "Documents", "Yes", "No"];
  const tableRows = [];

  tableRows.push([
    {
      content: "Job Details",
      colSpan: 4,
      styles: {
        halign: "center",
        valign: "middle",
        textColor: [0, 0, 0],
        fontStyle: "bold",
      },
    },
  ]);
  checkPointData.forEach((item, index) => {
    tableRows.push([
      index + 1,
      item.label,
      {
        content: item.value ? "Yes" : "",
        styles: { halign: "center", valign: "middle", font: "helvetica" },
      },
      {
        content: item.value ? "" : "No",
        styles: { halign: "center", valign: "middle", font: "helvetica" },
      },
    ]);

    if (index === 5) {
      tableRows.push([
        {
          content: "Tools/Accessories",
          colSpan: 4,
          styles: {
            halign: "center",
            fontStyle: "bold",
            fillColor: false,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
        },
      ]);
    }
  });

  doc.autoTable({
    margin: { left: config.margin, right: config.margin,
      bottom: config.margin + config.footerHeight + config.footerTableHeight + 10 // Updated bottom margin
    },
    startY,
    head: [tableColumn],
    body: tableRows,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 4,
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: false,
      textColor: 0,
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
    },
    bodyStyles: {
      halign: "left",
      valign: "middle",
    },
    columnStyles: {
      0: { cellWidth: 40 },
      1: { cellWidth: boxWidth - 240 },
      2: { cellWidth: 100 },
      3: { cellWidth: 100 },
    },
    didDrawPage: function () {
      drawMarginRect(doc);
      if (letterHead) {
        addHeaderFooter(doc, totalWidth);
      }
      // Draw signature footer on every page
      // drawSignatureFooter(doc, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
    },
  });
  startY = doc.lastAutoTable.finalY; 
}


export async function generateChallanPrint({
  companyName,
  allAddress,
  challanDetails,
  letterHead,
  selectedStdIDs,
  isCalibration,
  beforeCalibrationData,
  afterCalibrationData,
  instrumentData,
  checkPointData,
}) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "pt",
    format: "a4",
    compress: true,
  });
  const totalWidth = doc.internal.pageSize.getWidth();
  const totalHeight = doc.internal.pageSize.getHeight();

  await Promise.all([
    loadAndAddFont(
      doc,
      AptosNormal,
      "Aptos",
      customFontFamily?.normalFont,
      customFontFamily?.normal
    ),
    loadAndAddFont(
      doc,
      AptosBold,
      "Aptos-Bold",
      customFontFamily?.boldFont,
      customFontFamily?.bold
    ),
  ]);
  // Set default font
  doc.setFont(customFontFamily?.normalFont);
  doc.setFont(customFontFamily?.boldFont);

  const drawMarginRect = (doc) => {
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.rect(
      config?.borderMagin,
      config?.borderMagin + config?.headerHeight + config.bordergap,
      totalWidth - config?.borderMagin * 2,
      totalHeight -
        config?.borderMagin * 2 -
        (config?.headerHeight + config?.footerImgHeight + config?.footerTableHeight) -
        config.bordergap
    );
  };

  // Generate the content
  generateHeaderSection(doc, companyName, allAddress, challanDetails);

  drawCheckListTable(
      doc,
      drawMarginRect,
      checkPointData,
      letterHead,
      totalWidth
    );

  if (!isCalibration) {
    generateTableWithSummary(
      doc,
      selectedStdIDs,
      config?.margin,
      drawMarginRect,
      letterHead
    );
  } else {

    drawMasterReadingTable(
      doc,
      drawMarginRect,
      letterHead,
      totalWidth,
      beforeCalibrationData,
      afterCalibrationData,
      instrumentData
    );
  }


  const remainingHeight =
    totalHeight -
    config.currentY -
    config?.margin -
    config?.footerImgHeight -
    config?.footerTableHeight -
    config?.borderMagin;

  // Estimate height for additionalAccessories content
const lineHeight = config.fontSize;
const pageWidth = doc.internal.pageSize.getWidth();
const usableWidth = pageWidth - config.margin * 2;

// Split the text to fit within usable width
const accessoriesText =
  challanDetails?.additionalAccessories || "";
const lines = doc.splitTextToSize(accessoriesText, usableWidth * 1); // 0.8 is column width ratio
const termsHeight = lines.length * lineHeight; // Add padding if necessary
console.log({remainingHeight, termsHeight})

  if (remainingHeight >= termsHeight) {
    // If enough space is available on the same page
    additionalAccessoriesLabel(
      doc,
      challanDetails,
      doc.lastAutoTable.finalY + 10,
      config?.margin,
      totalWidth
    );
  } else {
    // If not enough space, create a new page
    doc.addPage();
    additionalAccessoriesLabel(
      doc,
      challanDetails,
      config?.borderMagin + config?.headerHeight + 5 + config.bordergap,
      config?.margin,
      totalWidth
    );
  }

  const totalPages = doc.getNumberOfPages();
  for (let page = 1; page <= totalPages; page++) {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(config.fontSize);
    doc.setTextColor(0);
    doc.setPage(page);
    let formatno = `Format No. - UCPL/F/MECH/05-00`;
    doc.text(
      formatno,
      config.margin,
      config?.headerHeight + config?.margin - 7,
      { align: "left" }
    );
    let content = `Page No : ${String(page).padStart(2, "0")} of ${String(
      totalPages
    ).padStart(2, "0")}`;
    doc.text(
      content,
      doc.internal.pageSize.getWidth() - config.margin - 70,
      config?.headerHeight + config?.margin - 7,
      { align: "left" }
    );
  }

  // In case there are pages that didn't trigger didDrawPage, loop through all pages to add header/footer
  if (letterHead) {
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addHeaderFooter(doc, letterHead);
      drawMarginRect(doc);
      drawSignatureFooter(doc, totalWidth, totalHeight);
    }
  }

  doc.save(`${companyName}.pdf`);
}
